export const COMPANY_TYPES = [
  "Lender", "Funder", "Equity Firm", "Broker", "Angel Investor",
  "Private Credit", "Family Office", "Challenger Bank",
];

export const FINANCE_TYPES = [
  // Business & working capital
  "Business Finance", "Unsecured Business Loan", "Secured Business Loan",
  "Working Capital", "Revolving Credit Facility", "Merchant Cash Advance",
  // Invoice
  "Invoice Finance", "Invoice Discounting", "Factoring", "Selective Invoice Finance",
  // Property
  "Commercial Mortgage", "Buy-to-Let Mortgage", "Property Development Finance",
  "Bridging", "Auction Finance", "Second Charge Bridging", "Refurbishment Finance",
  // Asset
  "Asset Finance", "Hire Purchase", "Finance Lease", "Operating Lease", "Asset Refinance",
  // Debt / structured
  "Debt Finance", "Mezzanine Finance", "Growth Debt", "Trade Finance",
  "Import/Export Finance", "Recovery Loan",
  // Equity
  "Equity/Investment", "Series A", "Series B+", "Angel Investment",
  "Private Equity", "Venture Debt",
  // Specialist
  "Litigation Finance", "R&D Tax Credit Advance", "VAT Loan", "Corporation Tax Loan",
];

export const INDUSTRY_SECTORS = [
  "Agriculture / Farming", "Automotive / Dealerships", "Aviation",
  "Construction", "Consulting / Professional Services", "Creative / Media / Design",
  "Ecommerce / DTC", "Education / Training", "Energy / Renewables",
  "Engineering", "Fashion / Apparel", "Financial Services", "Fintech",
  "Food & Beverage", "Franchise", "Gaming / iGaming", "Government / Public Sector",
  "Healthcare / Medical", "Hospitality / Hotels", "Import / Export",
  "Insurance / Insurtech", "Legal / Law Firm", "Logistics / Transport",
  "Manufacturing", "Marketing / Advertising", "Not-for-profit / Charity",
  "Pharma / Biotech", "Property Development",
  "Property Investment", "Real Estate Agency", "Restaurants / Cafes",
  "Retail (Bricks & Mortar)", "Security / Facilities",
  "SaaS / Software", "Sports / Fitness", "Telecoms",
  "Utilities", "Waste Management", "Wholesale / Distribution", "Other",
];

// Curated markets the network works across — kept in step with backend hub/config.py COUNTRIES.
export const COUNTRIES = [
  "United Kingdom", "Ireland",
  "United States", "Canada", "Australia", "New Zealand",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman",
  "South Africa", "Nigeria", "Kenya", "Ghana", "Egypt", "Mauritius",
  "India", "Pakistan", "Bangladesh", "Sri Lanka",
  "Singapore", "Hong Kong", "Malaysia", "Thailand", "Philippines", "Indonesia", "Vietnam",
  "China", "Japan", "South Korea",
  "Germany", "France", "Spain", "Portugal", "Italy", "Netherlands", "Belgium",
  "Luxembourg", "Switzerland", "Austria", "Sweden", "Norway", "Denmark", "Finland",
  "Poland", "Czech Republic", "Romania", "Greece", "Cyprus", "Malta",
  "Turkey", "Israel",
  "Brazil", "Mexico", "Argentina",
  "Other",
];


export const DECLINE_REASONS = [
  "Outside lending criteria",
  "Credit profile too weak",
  "Sector not supported",
  "Deal size out of range",
  "Cannot verify trading history",
  "Timing — cannot fund fast enough",
  "Applicant unresponsive",
  "Already declined by us previously",
  "Insufficient security offered",
  "Purpose not supported",
  "Other",
];

export const URGENCY_OPTIONS = [
  { key: "urgent",     label: "Urgent — within 7 days" },
  { key: "this_week",  label: "This week" },
  { key: "this_month", label: "This month" },
  { key: "flexible",   label: "Flexible" },
];

export const DELIVERY_METHODS = [
  { key: "dashboard", label: "Dashboard only" },
  { key: "email",     label: "Email only" },
  { key: "both",      label: "Dashboard + email" },
];

export const COMMISSION_TYPES = [
  { key: "revenue_share", label: "% of funded amount",         suffix: "%", hint: "Percentage of the funded finance amount, paid on completion" },
  { key: "flat_funded",   label: "Flat fee per funded deal",   suffix: "£", hint: "Fixed £ amount paid on funded completion" },
  { key: "flat_lead",     label: "Cost per qualified lead",    suffix: "£", hint: "Fixed £ amount paid when a lead reaches In Review or beyond" },
];

// The Hub can also set a share of the Connexis fee — not offered on the public application form,
// because an applicant has no way of knowing what a lender pays us.
export const ADMIN_COMMISSION_TYPES = [
  COMMISSION_TYPES[0],
  { key: "commission_share", label: "% of our commission", suffix: "%", hint: "Their share of the fee Connexis earns from the lender on that deal" },
  COMMISSION_TYPES[1],
  COMMISSION_TYPES[2],
];

export const COMMISSION_IS_PCT = (t) => t === "revenue_share" || t === "commission_share" || !t;

const COMMISSION_NOTE = {
  revenue_share: "of funded", commission_share: "of our fee",
  flat_funded: "per funded", flat_lead: "per lead",
};

/** Rate + wording for a partner's commission model, used in every list and header. */
export function commissionSummary(p) {
  const type = p?.commission_type || "revenue_share";
  const isPct = COMMISSION_IS_PCT(type);
  return {
    type, isPct,
    rate: isPct ? `${p?.commission_pct ?? 0}%` : `£${Math.round(p?.commission_flat_gbp || 0).toLocaleString()}`,
    note: COMMISSION_NOTE[type] || "of funded",
  };
}

export const STAGE_LABEL = {
  new: "Submitted", sent: "With lenders", in_review: "Under assessment",
  awaiting_docs: "Awaiting documents", preparing_offer: "Preparing offer",
  offer_made: "Offer issued", completed: "Funded", declined: "Declined",
};
export const STAGES = ["new", "sent", "in_review", "offer_made", "completed", "declined"];

export const COMPANY_ROLES = [
  "Founder / CEO", "Managing Director", "Finance Director", "CFO", "COO", "Company Secretary",
  "Owner", "Director", "Head of Finance", "Consultant / Broker (representing)", "Other",
];
